import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import NoSummaryBox from "../../common/summary/NoSummaryBox";

const NoSummary = () => {
  return (
    <Row spacing="none" spacingInset="none">
      <Row width="15px" />
      <Column spacing="none" spacingInset="none" alignment="top">
        <Column height="72px" />
        <NoSummaryBox />
      </Column>
    </Row>
  );
};

export default NoSummary;
